import { Store, render } from 'dooh-react-utils';
import { setup } from 'dooh-utils';
import '../node_modules/dooh-react-utils/dist/reset.css';
import '../node_modules/dooh-react-utils/dist/Screen.css';

import App from './App';
import './index.css';

setup('https://interaktivno.go2digital.hr/').then(({options={}, assets}) => {
  const store = new Store({
    screen: 'intro',
    session: null,
    time: 0,
  });

  window.store = store;

  const props = {options};
  render(App, store, props);
});



// WEBPACK FOOTER //
// ./src/index.js